const DISPLAY_NAME_FOR_DATA_TYPE = {
  live: 'live',
  publicTest: 'Playground',
};

export const displayNameForDataType = (
  dataType: 'live' | 'publicTest',
): string => DISPLAY_NAME_FOR_DATA_TYPE[dataType];
